export default "__VITE_ASSET__9a46cac5__"